<template>
    <div style="height: 100%">
		<v-card v-if="layout == 'BESD2'" :class="styles.card">
			<div :class="styles.text"
				@focusout="onEditableChange('text')"
                :contenteditable="editableContent"
                @paste="filterPastedContent"
                v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                class="responsive-text"
                :id="`${indexes.element}-${indexes.column}-${indexes.data}`"
			>

			</div>
			<v-card color="#06D6A0" class="besd-circle" elevation="0"></v-card>
		</v-card>
        <v-card v-else :outlined="styles.outlined" :elevation="styles.elevation"
            :class="styles.card"
            :style="styles.custom"
            height="100%"
        >
            <div :class="contentWrapper">
                <component :is="elementType"
                    :class="styles.text"
                    @focusout="onEditableChange('text')"
                    :contenteditable="editableContent"
                    @paste="filterPastedContent"
                    v-html='item.text.replace(/font-size: [^;]+;/g, "")'
                    class="responsive-text"
                    height="100%"
                    :id="`${indexes.element}-${indexes.column}-${indexes.data}-txtcard-text`"
                >
                </component>
                <div v-if="styles.subtitle" :class="styles.subtitle"
                    @focusout="onEditableChange('subtitle')"
                    :contenteditable="editableContent"
                    @paste="filterPastedContent"
                    v-html="item.subtitle"
                    class="responsive-subtitle"
                    :id="`${indexes.element}-${indexes.column}-${indexes.data}-txtcard-subtitle`"
                >
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>

export default {
    props: ["item", "styles", "indexes"],
    computed: {
        contentWrapper () {
            let className = ""
            if (this.layout == "BPM") className = "bpmeeting-content-wrapper px-5 py-5"
            if (["PH1", "PH2", "PH4", "PH6"].includes(this.layout)) className = "d-flex justify-center"

            return className
        },
        elementType () {
            const spans = ["BPM"]
            return spans.includes(this.layout) ? "span" : "div"
        }
    },
    methods: {
        onEditableChange (type) {
            this.columnEditableData("textcard2", this.indexes, type)
        }
    }
}
</script>

<style scoped>
.dark-blue {
  color: #131e56;
}

.perfect-reading-one-card {
    background: #0A85ED !important;
}

.ph4-outlined-card {
	border: 3px solid #8dd3f7 !important;
	padding: 1rem;
}

.milestone-card {
	background-color: #E2F2FF;
}

.milestone-border{
	border-radius: 20px !important;
	border: 3px solid #169bd6 !important;
}

.perfect-reading-two-bg {
	background: #DDDCE1;
}

.fsic1-card {
background-color: #D4D9FF;
}

.responsive-text{
font-size: min(4vw, 1.2em);
}

.responsive-subtitle{
font-size: min(3.5vw, 1em);
}

.besd-card {
	background: linear-gradient(to right top, #80ffdb, #ffffff);
}

.besd-circle {
	position: absolute;
	bottom: 0;
	right: 0;
	width: 40px;
	height: 40px;
	border-radius: 100px 0 0 0 !important;
	-moz-border-radius: 100px 0 0 0;
	-webkit-border-radius: 100px 0 0 0;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
}

.ie-text-card{
    background: #FFECD4;
}

.ph5-outlined-card {
  border: 1px solid #f6edd9 !important;
  background-color: #ffffff00 !important;
  height: 100%;
}

.cja-card {
    background-color: #8CD1D1;
    font-size: min(3.7vw, 1.2rem)
}
.cjb-card {
    background-color: #CBD2F5;
    font-size: min(4vw, 1.2em)
}
.cji-card {
    background-color: #F1DACD;
}

.meeting-highlighted-string-white {
  background: linear-gradient(to top, #ffffff 50%, #41feaf 50%);
}

.bpmeeting-content-wrapper {
    border: 5px solid black;
    height: 100%;
}
</style>
